// extracted by mini-css-extract-plugin
export default {"skipLink":"SkipLink_skipLink__SJ8rd"};